export const operatorTypes = {
  INVITE_OPERATORS_START: 'INVITE_OPERATORS_START',
  FETCH_OPERATORS_START: 'FETCH_OPERATORS_START',
  EDIT_OPERATOR_PROFILE_START: 'EDIT_OPERATOR_PROFILE_START',
  REMOVE_OPERATOR_START: 'REMOVE_OPERATOR_START',
  EDIT_OPERATOR_START: 'EDIT_OPERATOR_START',
  UPDATE_REMOVED_OPERATOR: 'UPDATE_REMOVED_OPERATOR',
  SET_OPERATORS: 'SET_OPERATORS',
  LOADING_OPERATORS: 'LOADING_OPERATORS',
  SET_CURRENT_OPERATOR: 'SET_CURRENT_OPERATOR',
  RESET_CURRENT_OPERATOR: 'RESET_CURRENT_OPERATOR',
  SET_EDITED_OPERATOR: 'SET_EDITED_OPERATOR',
  SAVE_TO_EDITED_OPERATOR: 'SAVE_TO_EDITED_OPERATOR',
  FETCH_OPERATOR_REPORTS_START: 'FETCH_OPERATOR_REPORTS_START',
  SET_OPERATOR_REPORTS: 'SET_OPERATOR_REPORTS',
  FETCH_OPERATORS_BETWEEN_DAYS_START: 'FETCH_OPERATORS_BETWEEN_DAYS_START',
  SET_OPERATORS_TABLE_DATA: 'SET_OPERATORS_TABLE_DATA',
  FETCH_WEEKLY_CHOSEN_OPERATOR: 'FETCH_WEEKLY_CHOSEN_OPERATOR',
  LOADING_WEEKLY_CHOSEN_OPERATOR: 'LOADING_WEEKLY_CHOSEN_OPERATOR',
  SET_WEEKLY_CHOSEN_OPERATOR: 'SET_WEEKLY_CHOSEN_OPERATOR',
  FETCH_SORTED_OPERATORS_LIST_START: 'FETCH_SORTED_OPERATORS_LIST_START',
  SET_SORTED_OPERATORS_LIST: 'SET_SORTED_OPERATORS_LIST',
  LOADING_SORTED_OPERATORS_LIST_START: 'LOADING_SORTED_OPERATORS_LIST_START',
  VALIDATE_ENTERED_VERIFICATION_CODE: 'VALIDATE_ENTERED_VERIFICATION_CODE',
  CHANGE_OPERATOR_MOBILE_NUMBER: 'CHANGE_OPERATOR_MOBILE_NUMBER',
};
